import { mapState } from 'vuex';

// Install the components
export function install(Vue) {
  Vue.mixin({
    computed: {
      ...mapState({
        loggedIn: state => state.auth.authenticated,
        user: state => state.auth.user,
      }),
    },
  });
}

// Plugin
const plugin = {
  /* eslint-disable no-undef */
  version: '1.0',
  install,
};

export default plugin;
